
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'

@Observer
@Component({
  components: {
    InfiniteLoading,
    EmptyStatus
  }
})
export default class ExchangeRecord extends Vue {
  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get pagePagination() {
    return this.$store.$myV2.Account.Exchange.recordPagePagination
  }
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
